<template>
  <v-sheet dark class="mt-2 mb-3 px-4 py-3 blue darken-2 text-left align-center">
    <v-row>
      <v-col cols="6" md="2">
        <v-autocomplete
            :items="managers"
            v-model="filters.manager"
            label="Manager"
            dense
            outlined
            hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" md="2">
        <v-autocomplete
            :items="agents"
            v-model="filters.agent"
            label="Added by"
            dense
            outlined
            clearable
            hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" md="2">
        <v-select
            :items="options"
            v-model="filters.option"
            label="Option"
            dense
            outlined
            hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" md="2">
        <v-checkbox
            v-model="filters.is_complete"
            label="Closed"
            dense
            hide-details
            class="mt-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="6" md="2">
        <v-checkbox
            v-model="filters.is_declined"
            label="Declined"
            dense
            hide-details
            class="mt-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="6" md="2">
        <v-checkbox
            v-model="filters.is_withdrawn"
            label="Withdrawn"
            class="mt-0"
            dense
            hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="6" md="2">
        <v-checkbox
            v-model="filters.is_comfort_letter_received"
            label="Comfort Letter"
            dense
            hide-details
            class="mt-0"
        ></v-checkbox>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>

import {errorNotification} from "@/components/utils";

export default {
  components: {},
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  name: 'ApplicationsFilter',
  data() {
    return {
      // filters: {...this.filter},
      filters: this.$store.getters['search/applications']['filters'],
      agents: [],
      managers: [],
      options: []
    }
  },
  computed: {},
  watch: {
    filters: {
      handler() {
        this.$emit('update:filter', this.filters)
      },
      deep: true
    }
  },
  methods: {
    fetchOptions() {
      this.$axios.options('/applications/filters/', {})
          .then((response) => {
            this.agents = [{'text': 'All', 'value': ''}].concat(response.data.agents)
            this.managers = [{'text': 'All', 'value': ''}].concat(response.data.managers)
            this.options = [{'text': 'All', 'value': ''}].concat(response.data.options)
          })
          .catch((error) => {
            errorNotification(error)
          })
    }
  },
  mounted() {
    this.fetchOptions()
  }
}
</script>